import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import { Input } from 'components/Controls';
import Accordion from 'components/Accordion';
// Utilities
import { isRequired, noWhitespace } from 'utilities/validation';

const SectionMain:FC = () => {
  const { t } = useTranslation();

  const { control, formState: { errors } } = useFormContext();

  return (
    <div react-scroll="main">
      <Accordion label={t('labels.main')} icon="list" defaultExpanded>
        <div className="w-full">
          <span className="block text-gray-400 text-sm font-light leading-5 mb-4">{t('pages.groupForm.hint1')}</span>
          <span className="block text-gray-400 text-sm font-light leading-5 mb-4">{t('pages.groupForm.hint2')}</span>
          <Controller
            control={control} name="name" rules={{ required: isRequired, validate: noWhitespace }}
            render={({ field: { value, onChange } }) => (
              <Input
                label={t('labels.name')} id="name" name="name" value={value}
                required={true}
                onChange={onChange}
                error={Boolean(errors.name)}
                errorText={errors.name ? errors.name.message : ''}
              />
            )}
          />
          <Controller
            control={control} name="passcode"
            render={({ field: { value, onChange } }) => (
              <Input
                label={t('labels.passcode')} id="passcode" name="passcode" value={value}
                onChange={onChange}
                error={Boolean(errors.passcode)}
                errorText={errors.passcode ? errors.passcode.message : ''}
              />
            )}
          />
          <span className="block text-gray-400 text-sm font-light leading-5 mb-4">{t('pages.groupForm.passcodeHint')}</span>
        </div>
      </Accordion>
    </div>
  )
}

export default SectionMain;
